import { margin, Theme } from '@mui/system'
import { makeStyles } from '@mui/styles'
import { FONTS } from 'src/constants'

const useStyles = makeStyles((theme: Theme) => ({
  button: {
    '&&': {
      borderRadius: '5px',

      fontSize: FONTS.SIZES.s,
      textTransform: 'none',
      fontWeight: FONTS.WEIGHTS.bold,

      // height: 40,
    },
  },
}))

export { useStyles }
